import { Colors, Row, Skeleton } from '@microfrontends/react-components'
import styled from 'styled-components'

const sectionPadding = '35px 0'

export const Container = styled(Row)`
	background-color: #fff;
	overflow: hidden;
`
export const TopTitleCss = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
	width: 100%;
	height: 100%;
`
export const H1 = styled.h1`
	position: relative;
	font-family: 'Dela Gothic One';
	font-style: normal;
	font-weight: 400;
	font-size: 8.5vw;
	color: #fff;
	.title__cover {
		position: absolute;
		transform: scale(3);
		top: 20%;
		left: 60%;
	}
	span {
		color: ${Colors.button};
	}
	@media (min-width: 768px) {
		font-size: 50px;
	}
	@media (min-width: 1200px) {
		font-size: 60px;
	}
`

export const AboutWrap = styled.section`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: ${sectionPadding};
`
export const About = styled(Row)`
	&.row-reverse {
		flex-direction: row-reverse;
	}
	.collapse {
		div:has(> span) {
			display: inline-block;
			color: #005aff;
			cursor: pointer;
		}
	}
`
export const RulingNumberContainer = styled(Row)`
	background-color: ${Colors.primary};
	background-image: url(${process.env.IMAGE_BASE_URL}/numerology/base-bg.png);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	padding: ${sectionPadding};
`
export const MyRulingNumberCss = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 30px;
	font-style: normal;
	font-weight: 400;
	font-size: 20px;
	line-height: 24px;
	color: #ffffff;
	margin-bottom: 15px;
	cursor: pointer;
	.block {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		p {
			margin-bottom: 0;
		}
	}
	h3 {
		font-family: 'Dela Gothic One';
	}

	.line {
		position: relative;
		height: 63px;
		width: 0;
		border: 1px dashed #000000;
		z-index: 9;
		&::before,
		&::after {
			position: absolute;
			content: '';
			width: 5px;
			height: 5px;
			top: -1%;
			left: 50%;
			transform: translateX(-50%) rotate(45deg);
			z-index: 9;
			background-color: #000000;
		}
		&::after {
			top: 101%;
		}
	}
`
export const ArticleCss = styled.section`
	background: #f1f1f1;
	padding: ${sectionPadding};
`

export const Box = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	&.center {
		align-items: center;
		justify-content: center;
		text-align: center;
	}
	&.row {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		&.custom-gap {
			gap: 30px 20px;
			margin-top: 40px;
		}
	}
	@media screen and (min-width: 768px) {
		align-items: flex-start;
	}
`

export const WrapSkeletonCss = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
`
export const CustomSkeleton = styled(Skeleton)`
	border-radius: 50%;
`
export const ResponsibilityCss = styled(Row)`
	padding: ${sectionPadding};
`
export const BooksCss = styled(Row)`
	padding: ${sectionPadding};
	padding-top: 0;
`
export const FamousPeopleCss = styled(Row)`
	padding: ${sectionPadding};
`
export const RecommendJobsCss = styled(Row)`
	padding: ${sectionPadding};
	background: #f1f1f1;
`
export const CustomLink = styled.a`
	color: ${Colors.text};
	:hover {
		color: ${Colors.text};
	}
`
export const CustomIframe = styled.iframe`
	width: 100%;
	min-height: 205px;
`
